import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { alertActions, federalReviewActions } from '_actions';
import {
    PatientDot,
    PatientCareCenterButton,
    LoadingIcon,
    TrashButton,
    ReplyButton,
    SaveButton,
    CancelButton
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'

class PeerReviewFederalDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            replyMsg: ''
        };
    }

    handleChange(event) {
        this.setState({ replyMsg: event.target.value });
    }

    reply() {
        if (this.state.replyMsg.trim() !== '') {
            this.props.reply(this.props.message.nomxno, this.state.replyMsg, this.props.message.urno);
            this.setState({ replyMsg: '' });
        } else {
            this.props.alertWarning('You must supply a message to reply with.');
        }
    }

    close() {
        this.props.close(this.props.message.nono);
    }

    render() {
        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Peer Review - Federal: {this.props.message.ptname}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Admission:</div>
                            </div>
                            <div className={styles.data}>
                                <div className={styles.italic}>
                                    <span className={styles.patient_dot}><PatientDot id={this.props.message.dot} /></span>
                                    {' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}
                                </div>
                                <div>
                                    {this.props.admissions && this.props.admissions.length > 0 ? Object.keys(this.props.admissions)
                                        .map(key => {
                                            const adm = this.props.admissions[key];
                                            return <div key={adm.epno}>
                                                {adm.admissionDesc + ' - ' + adm.discipline + ' - ' + adm.locationName}
                                            </div>
                                        }) : <span />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                {this.props.message.type !== 13 &&
                                    <span className={styles.button}><ReplyButton onClick={() => this.props.toggleReply()} /></span>
                                }
                                {this.props.message.type === 13 &&
                                    <span className={styles.button}><TrashButton onClick={() => this.close()} /></span>
                                }
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    {this.props.replyVisible &&
                        <div className={styles.reply_wrapper}>
                            <div className={styles.reply_header}>Reply</div>
                            <div className={styles.reply_body} >
                                <div className={styles.reply_text_area_wrapper} >
                                    <textarea maxLength={3000} autoFocus name="replyMsg" type="text" className={styles.reply_text_area} rows="4" value={this.state.replyMsg} onChange={e => this.handleChange(e)} />
                                </div>
                                <div className={styles.reply_buttons_wrapper} >
                                    <div className={styles.reply_buttons_block} >
                                        <span className={styles.button} ><SaveButton onClick={() => this.reply()} /></span>
                                        <span className={styles.button} ><CancelButton onClick={() => this.props.toggleReply()} /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className={styles.wrapper}>
                        {this.props.messageHistory && this.props.messageHistory.length > 0 ? Object.keys(this.props.messageHistory)
                            .map(key => {
                                const historyEntry = this.props.messageHistory[key];
                                return <div key={historyEntry.mgno} className={styles.message_wrapper} >
                                    <div className={styles.message_header} >{new Date(historyEntry.addDate).toLocaleString("en-US") + " - Message by " + historyEntry.addUser}</div>
                                    <div className={styles.message_content} >{historyEntry.message}</div>
                                </div>
                            }) : <span />
                        }
                        {this.props.message.type === 13 &&
                            <div className={styles.message_wrapper} >
                                <div className={styles.message_header} >{new Date(this.props.message.requestDate).toLocaleString("en-US") + " - Message by " + this.props.message.addUserName}</div>
                                <div className={styles.message_content} >{'Federal Payer Review Initiated'}</div>
                            </div>
                        }
                    </div>


                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Peer Review - Federal</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleReply: bindActionCreators(federalReviewActions.toggleReply, dispatch),
        reply: bindActionCreators(federalReviewActions.reply, dispatch),
        close: bindActionCreators(federalReviewActions.closeNotification, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.federalReviewMsgs[state.ui.federalReviewMsgs.selectedMessage];
    let messageHistory = message ? Object.keys(state.entities.federalReviewMsgDetails)
        .filter(key => { return state.entities.federalReviewMsgDetails[key].mgmxno === message.nomxno; })
        .sort((a, b) => new Date(state.entities.federalReviewMsgDetails[b].addDate) - new Date(state.entities.federalReviewMsgDetails[a].addDate))
        .map(key => state.entities.federalReviewMsgDetails[key])
        : undefined;
    let admissions = message ? Object.keys(state.entities.federalReviewMsgAdmissions)
        .filter(key => { return state.entities.federalReviewMsgAdmissions[key].mxno === message.nomxno; })
        .sort((a, b) => new Date(state.entities.federalReviewMsgAdmissions[b].startDate) - new Date(state.entities.federalReviewMsgAdmissions[a].startDate))
        .map(key => state.entities.federalReviewMsgAdmissions[key])
        : undefined;

    return {
        message,
        loading: state.ui.federalReviewMsgs.loading,
        messageHistory,
        admissions,
        replyVisible: state.ui.federalReviewMsgs.replyVisible
    };
}


const connectedPeerReviewFederalDetails = connect(mapStateToProps, mapDispatchToProps)(PeerReviewFederalDetails);
export { connectedPeerReviewFederalDetails as PeerReviewFederalDetails };
